import { COLORS } from "@store/theme/common/design";

export default {
    primary: {
        main: COLORS.primary.base,
        contrast: COLORS.white,
        // Custom
        light: COLORS.primary.light,
        dark: COLORS.primary.dark,
    },
    secondary: {
        main: COLORS.secondary.base,
        contrast: COLORS.white,
        // Custom
        light: COLORS.secondary.light,
        dark: COLORS.secondary.dark,
    },
    tertiary: {
        main: COLORS.tertiary.base,
        contrast: COLORS.white,
        // Custom
        light: COLORS.tertiary.light,
        dark: COLORS.tertiary.dark,
    },
    common: {
        background: COLORS.white,
        backgroundContrast: COLORS.text.base,
        accent: COLORS.background.alt,
        accentContrast: COLORS.text.base,
        border: COLORS.border.base,
        disabled: COLORS.disabled.base,
        // Custom
        disabledLighter: COLORS.disabled.lighter,
        disabledLight: COLORS.disabled.light,
        borderDark: COLORS.border.dark,
        borderDarker: COLORS.border.darker,
        backgroundHover: COLORS.background.hover,
    },
    text: {
        main: COLORS.text.light,
        titles: COLORS.text.base,
        disabled: COLORS.text.lighter,
        accent: COLORS.text.light,
        link: COLORS.link.base,
        // Custom
        linkHover: COLORS.link.hover,
        lighter: COLORS.text.lighter,
    },
    success: {
        main: COLORS.success,
        contrast: COLORS.white,
    },
    danger: {
        main: COLORS.error,
        contrast: COLORS.white,
    },
    warning: {
        main: COLORS.warning,
        contrast: COLORS.white,
    },
    unavailable: {
        main: COLORS.tertiary.base,
        contrast: COLORS.white,
    },
    info: {
        main: COLORS.info,
        contrast: COLORS.text.base,
    },
    // Custom
    pagination: {
        main: COLORS.pagination.base,
        hover: COLORS.pagination.hover,
    },
    user: {
        guest: COLORS.secondary.light,
        b2c: COLORS.secondary.dark,
        b2b: COLORS.primary.base,
    },
    placeholder: {
        main: COLORS.text.thelightest,
        disabled: COLORS.text.thelightest,
    },
};
